import {useQuery} from '@tanstack/react-query';

import {getOnboarding} from '../api';
import {QUERY__ONBOARDING} from '../queryKeys';
import {OnboardingType} from '../types';

export const useGetOnboarding = (type: OnboardingType | undefined) => {
  return useQuery({
    queryKey: [QUERY__ONBOARDING, type],
    queryFn: () => getOnboarding(type as OnboardingType),
    enabled: !!type,
  });
};
